import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Auth0Service {
  private _config = environment.alleAuthConfig;

  constructor(private _http: HttpClient) { }

  changePassword(email): Observable<any> {
    const url = `https://${this._config.domain}/dbconnections/change_password`
    const data = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      client_id: this._config.clientID,
      email,
      connection: this._config.connection
    };

    return this._http.post(url, data, { responseType: 'text' });
  }
}
